<template>
  <div
    class="w-full pt-[78px] desktop:pt-[94px] tablet-h:pt-10 tablet-v:pt-[111px] text-[22px] leading-[28px] text-gray-800 font-primary font-semibold text-center flex flex-col items-center px-6"
  >
    <div class="w-full max-w-[450px] flex flex-col flex-grow">
      <div class="max-w-[350px] tablet-v:w-full mx-auto mb-5">
        {{ question }}
      </div>

      <div class="mt-auto w-full">
        <div class="flex flex-col gap-y-[9px] mb-[30px]">
          <SelectOption v-model="answer" icon="⚡" value="Daily">
            Daily
          </SelectOption>
          <SelectOption v-model="answer" icon="📅" value="Weekly">
            Weekly
          </SelectOption>
          <SelectOption v-model="answer" icon="📅" value="Monthly">
            Monthly
          </SelectOption>
          <SelectOption v-model="answer" icon="📅" value="Every few months">
            Every few months
          </SelectOption>
          <SelectOption v-model="answer" icon="📅" value="Yearly">
            Yearly
          </SelectOption>
        </div>

        <UiButton
          class="w-full"
          :disabled="!answer"
          primary
          large
          @click="handleClick"
        >
          Next
        </UiButton>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { UiButton } from '@dacr/ui'
import SelectOption from '@/shared/components/SelectOption.vue'
import { computed } from 'vue'
import { useCompleteStepMutation } from '@/shared/graphql/legacy/generated'
import { OnboardingStep, useOnboardingStore } from '@/features/onboarding/store'

const { mutate: completeStep } = useCompleteStepMutation()

const onboardingStore = useOnboardingStore()

const question = 'How often do you or your organization produce work?'

const answer = computed({
  get() {
    return (onboardingStore.state[OnboardingStep.Four] || '') as string
  },
  set(value: string) {
    onboardingStore.state[OnboardingStep.Four] = value
  },
})

const handleClick = () => {
  completeStep({
    step: 4,
    question,
    answers: [answer.value],
  })

  onboardingStore.goToNextStep({
    question,
    answers: [answer.value],
  })
}
</script>
